export default __webpack_public_path__ + "static/NotYou-51a5cf9a042697757c20f770c438d2d4.png";